import { useEffect, useState } from "react";
import { getPermission } from "../SessionManagement";

const usePermission = () => {
  const [userPermission, setUserPermission] = useState("");
  const [isGuest, setIsGuest] = useState<boolean>(true);
  const [isDev, setIsDev] = useState<boolean>(true);

  let permission = getPermission();

  useEffect(() => {
    if (permission) setUserPermission(permission);
    setIsGuest(permission === "guest");
    setIsDev(permission === "developer" || permission === "admin");
  }, [permission]);

  // isGuest initial state is true until the actual permission is returned
  // use userPermission if you need undefined as initial state
  return { userPermission, isGuest, isDev };
};

export default usePermission;
